import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import ViewReviewHeader from "src/components/pages/Summary/ViewReview/ViewReviewHeader";
import Section from "src/components/shared/EntriesGenerator/Section/Section/Section";
import CheckListsModal from "src/generator/_Modals/CheckListsModal/CheckListsModal";
import { useVerifyEntries } from "src/pages/Summary/Summary.hooks";
import VerificationSignature from "src/pages/Summary/VerifyEntries/VerificationSignature/VerificationSignature";
import { useSelector } from "src/redux/hooks";
import { PageContainer } from "src/styled";
import { getYachtId } from "src/utils";

const ViewReviewEntry = () => {
  const { idType, lbeidOrPartId, aid } = useParams();
  const [searchParams] = useSearchParams();
  const yachtid = searchParams.get("yachtid") ?? getYachtId();
  const reduxYachtuser = useSelector(state => state.permsSlice.yachtuser);
  const yachtuserParam = searchParams.get("yachtuser");
  const yachtuser = yachtuserParam !== null ? yachtuserParam === "1" : reduxYachtuser;
  const { sections, restricted, authorized, lbid, idata, ...headerProps } =
    useVerifyEntries(
      "get-review-entry-reviews",
      yachtuser ? "get-reviews" : "get-reviews-flag",
      {
        params: {
          yachtid,
          [String(idType)]: lbeidOrPartId,
          aid,
        },
      },
      yachtid,
    );

  useEffect(() => {
    sections.length && console.log({ summarySections: sections });
  }, [sections]);

  return (
    <PageContainer>
      <ViewReviewHeader {...headerProps} />
      {/* {restricted === true && authorized === false ? (
        <AuthLogbookModal
          opened={true}
          open={open}
          close={close}
          lbid={lbid ?? ""}
        />
      ) : null} */}

      {(!restricted && !authorized) ||
      (restricted === true && authorized === true)
        ? sections.map((s, i) => <Section key={i} sIndex={i} section={s} />)
        : null}

      {idata && <VerificationSignature idata={idata} title="Signature" />}

      <CheckListsModal type="summary" />
    </PageContainer>
  );
};

export default ViewReviewEntry;
